function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from 'modules/PatientResults/messages';
import styles from './BgmValuesInRangesReportChart.pcss';
var _React_PureComponent;
class BgmValuesInRangesReportChart extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { timeInRanges } = this.props;
        const veryHighRange = timeInRanges.find(({ name })=>name === 'veryHigh');
        const veryLowRange = timeInRanges.find(({ name })=>name === 'veryLow');
        const filteredTimeInRanges = timeInRanges.filter((range)=>range !== veryHighRange && range !== veryLowRange);
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.bgmValuesInRangeChart,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "legend__header",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "legend__headerPrecentage",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.ofTotal))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "legend__headerChecks",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.checks))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "barChart",
                            children: this.props.timeInRanges.map((timeInRange)=>/*#__PURE__*/ _jsx("div", {
                                    className: cn('barChart__section', `barChart__section--${timeInRange.name}`, {
                                        'barChart__section--transparent': !timeInRange.percent
                                    }),
                                    style: {
                                        height: `${timeInRange.percent || 0}%`
                                    }
                                }, timeInRange.name))
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "legend",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "legend__section legend__section--first",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "legend__sectionLabels",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "legend__sectionLabelName",
                                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[veryHighRange.name]))
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "legend__sectionLabelTarget",
                                                children: [
                                                    "(",
                                                    veryHighRange.range,
                                                    " ",
                                                    this.props.conversion.unitSymbol,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "legend__divider"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "legend__sectionLabelPercent",
                                                children: veryHighRange.percent ? `${veryHighRange.percent}%` : '0%'
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "legend__dividerBeforeCount"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "legend__sectionLabelTime",
                                                children: veryHighRange.count
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "legend__section",
                                    style: veryHighRange.percent ? {
                                        height: `${veryHighRange.percent || 0}%`
                                    } : {
                                        height: 'auto'
                                    }
                                }),
                                filteredTimeInRanges.map((timeInRange)=>/*#__PURE__*/ _jsx("div", {
                                        className: "legend__section",
                                        style: timeInRange.percent ? {
                                            height: `${timeInRange.percent || 0}%`
                                        } : {
                                            height: 'auto'
                                        },
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "legend__sectionLabels",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "legend__sectionLabelName",
                                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[timeInRange.name]))
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "legend__sectionLabelTarget",
                                                    children: [
                                                        "(",
                                                        timeInRange.range,
                                                        " ",
                                                        this.props.conversion.unitSymbol,
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "legend__divider"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "legend__sectionLabelPercent",
                                                    children: timeInRange.percent ? `${timeInRange.percent}%` : '0%'
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "legend__dividerBeforeCount"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "legend__sectionLabelTime",
                                                    children: timeInRange.count
                                                })
                                            ]
                                        })
                                    }, timeInRange.name)),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "legend__section",
                                    style: veryLowRange.percent ? {
                                        height: `${veryLowRange.percent || 0}%`
                                    } : {
                                        height: 'auto'
                                    }
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "legend__section legend__section--last",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "legend__sectionLabels",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "legend__sectionLabelName",
                                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[veryLowRange.name]))
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "legend__sectionLabelTarget",
                                                children: [
                                                    "(",
                                                    veryLowRange.range,
                                                    " ",
                                                    this.props.conversion.unitSymbol,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "legend__divider"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "legend__sectionLabelPercent",
                                                children: veryLowRange.percent ? `${veryLowRange.percent}%` : '0%'
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "legend__dividerBeforeCount"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "legend__sectionLabelTime",
                                                children: veryLowRange.count
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(BgmValuesInRangesReportChart, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    timeInRanges: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
        range: PropTypes.string.isRequired
    }))
});
export default withStyles(styles)(BgmValuesInRangesReportChart);
